module.exports = __webpack_public_path__ + "components/MapControl/svg/Sanatorium.svg?e3978fe4";


//////////////////
// WEBPACK FOOTER
// ./components/MapControl/svg/Sanatorium.svg
// module id = 1992
// module chunks = 0